export default __webpack_public_path__ + "static/banner2x-b8725d8606247514940c0159419e5b52.png";